import { captureException } from 'src/shared/helpers/captureException';
import type ApolloClient from 'apollo-client';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CoachAssignmentNode } from 'src/generated/webapp_gql';
import { isAuthenticated } from 'src/modules/auth/selectors/authenticationSelectors';
import {
    GetMyProvidersDocument,
    GetMyProvidersQuery,
} from 'src/modules/providers/documents/getMyProvidersQuery.generated';
import type { Dispatch } from './rootStore';

/**
 * A simple component to watch queries and populate our legacy Redux
 * store.
 */
export const ApolloToReduxSyncManager = ({ client }: { client: ApolloClient<unknown> }) => {
    const dispatch = useDispatch<Dispatch>();
    const authenticated = useSelector(isAuthenticated);

    useEffect(() => {
        if (!authenticated) return;

        try {
            const subscription = client
                .watchQuery<GetMyProvidersQuery>({ query: GetMyProvidersDocument })
                .subscribe(value => {
                    if (!value.data?.coachAssignments) return;

                    dispatch.providers.addMyProviders(
                        value.data.coachAssignments as CoachAssignmentNode[],
                    );
                });

            // Remove this subscription...
            return () => {
                subscription.unsubscribe();
            };
        } catch (error) {
            captureException(error);
        }
        return () => {};
    }, [client, dispatch.providers, authenticated]);

    return null;
};
